<template>
	<div style="display: inline;">
		<template v-if="device!='pc'">

			<van-button style="width: 100%;" type="default" @click="commentShow=true">
				<template slot >
					意见 <div class="van-badge" v-if="commentcount">{{commentcount}}</div>
				</template>
			</van-button>

			<van-popup v-model="commentShow" :style="{ height: '90%' ,width:'90%'}" :lazy-render="true"
				get-container="body" :safe-area-inset-bottom="true">
				<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
					<div class="full" style="position: relative;flex: 1;">
						<comment @doSend="doSend($event)" @doChidSend="doChidSend(arguments)" :commentList="commentList"
							:canReplay="controlltype!=3" :commentNum="commentNum" :label="label" :avatar="avatar"
							:placeholder="placeholder" :key="commentKey"></comment>
					</div>
					<van-button type="default" @click="commentShow=false" block>返回</van-button>
				</div>
			</van-popup>
		</template>
		<template v-else>
			<el-badge :value="commentcount?commentcount:null" style="margin-right: 10px;">
				<vxe-button content="处理意见" status="danger" size="mini" @click="commentShow=true">
				</vxe-button>
			</el-badge>
			<vxe-modal transfer v-model="commentShow" width="1000" height="600" :destroy-on-close="true" title="处理人意见区"
				show-footer>
				<template #default>
					<div class="full" style="overflow-y: auto;overflow-x: hidden;">
						<comment @doSend="doSend($event)" @doChidSend="doChidSend(arguments)" :commentList="commentList"
							:canReplay="controlltype!=3" :commentNum="commentNum" :label="label" :avatar="avatar"
							:placeholder="placeholder" :key="commentKey"></comment>
					</div>
				</template>
			</vxe-modal>
		</template>
	</div>


</template>
<style scoped>
	.tinymce {
		position: relative;
		width: 100%;
		height: 300px;
	}
</style>
<script>
	import comment from './comment/Comment.vue'
	export default {
		props: {
			id: {
				default: () => {
					return ''
				}
			},
			name: {
				default: () => {
					return ''
				}
			},
			controlltype: {
				default: () => {
					return 3
				}
			},
			flowprogressType: {
				default: () => {
					return 0
				}
			},

			flowprogressid: {
				default: () => {
					return 0
				}
			},
			// formConfig: {
			// 	type: Object,
			// 	default: () => {
			// 		return {
			// 			name: '',
			// 			id: 0,
			// 			controlltype: 1,
			// 			foreingKey: {},
			// 			extra: {},
			// 			windowName: '',
			// 			windowType: 'modal'
			// 		}
			// 	}
			// },

		},
		data() {
			return {
				comment: '',
				commentcount: null,
				commentShow: false,
				label: "",
				placeholder: "",
				commentNum: 0,
				avatar: '',
				commentList: [],
				commentKey: Math.random()
				// commentList: [{
				// 	id: 1,
				// 	commentUser: {
				// 		id: 1,
				// 		nickName: "花",
				// 		avatar: "",
				// 	},
				// 	content: "<a style='text-decoration:none;color: #409eff ' href='https://blog.csdn.net/qq_40942490?spm=1000.2115.3001.5113'>我的CSDN博客地址</a>[害羞][害羞][害羞]<br/>",
				// 	createDate: "2019-9-23 17:36:02",
				// 	childrenList: [{
				// 		id: 2,
				// 		commentUser: {
				// 			id: 2,
				// 			nickName: "坏菠萝",
				// 			avatar: "",
				// 		},
				// 		targetUser: {
				// 			id: 1,
				// 			nickName: "花非花",
				// 			avatar: "",
				// 		},
				// 		content: "真的就很棒！很Nice!",
				// 		createDate: "2019-9-23 17:45:26",
				// 	}]
				// }]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {
			this.list()
		},
		mounted() {
			if (this.flowprogressType == 2) {
				this.commentShow = true
			}
		},
		methods: {
			list() {
				if (!this.id || !this.name) {
					return
				}
				this.$api.flowprogress.getComment({
					id: this.id,
					name: this.name,
					flowprogressid:this.flowprogressid
				}).then((res) => {
					this.commentcount = res.count
					let content = res.content
					let list = []
					let commentList = []
					this.commentNum = content.length
					content.forEach((item) => {
						let obj = {
							id: item.id,
							parentid: item.parentid,
							commentUser: {
								id: item.fromstaffid,
								nickName: item.fromstaffname,
								avatar: ''
							},
							content: item.content,
							createDate: item.create_time,
							childrenList: []
						}
						if (item.parentid != 0) {
							obj.targetUser = {
								id: item.targetstaffid,
								nickName: item.targetstaffname,
								avatar: ''
							}
						}
						list.push(obj)
					})
					list.forEach((item) => {
						commentList.push(item)
					})
					this.commentList = commentList
				})
			},
			doSend(content) {
				console.log("初始发送按钮点击事件：" + content);
			},

			doChidSend(args) {
				if (!args[0]) {
					this.$message.error('请填写评论')
				} else {
					this.$api.flowprogress.replyComment(args[2], {
						content: args[0]
					}).then(() => {
						this.commentKey = Math.random()
						this.list()
					})
				}
				// console.log(args);
				// console.log("content=" + args[0]);
				// console.log("targetUserId=" + args[1]);
				// console.log("父级评论id=" + args[2]);
			},

		},
		components: {
			comment,

		}
	}
</script>
